module.exports = __webpack_public_path__ + "static/media/question_mark.37576c4b.svg";